import { FC } from 'react';
import UiTabs, { type ITabsProps as IUiTabsProps } from '@srm/ui/tabs';
import { formulaTraceAttrs } from '@/context/DocumentFormulaTraceContext';

export type ITabsProps = Omit<IUiTabsProps, 'tabDataAttributes'>;

const formulaTraceTabAttrs = (value: string) => formulaTraceAttrs(value, 'tab');

// Компонент живёт в @srm/ui; обёртка вешает на кнопки вкладок якоря диагностики формул документа.
const Tabs: FC<ITabsProps> = (props: ITabsProps) => <UiTabs {...props} tabDataAttributes={formulaTraceTabAttrs} />;

export default Tabs;
